import { Link } from "react-router-dom";

const Dashboard = () => {
  return (
    <>
      <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 class="h2">Dashboard</h1>
      </div>
      <div className="row">
        <div className="col-lg-3">
          <div class="card mb-3">
            <div class="card-body">
              <h5 class="card-title">Contact QR Code</h5>
              <p class="card-text">
                Generate Contact QR Code
              </p>
              <Link to={"/contact-qrcode"} class="btn btn-primary">Click Now</Link>
            </div>
          </div>
        </div>
         <div className="col-lg-3">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">URL QR Code</h5>
              <p class="card-text">
                Generate Contact QR Code
              </p>
              <Link to={"/url-qrcode"} class="btn btn-primary">Click Now</Link>
            </div>
          </div>
        </div>
        <div className="col-lg-3">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Word to PDF Conversion</h5>
              <p class="card-text">
                Convert your word files to pdf
              </p>
              <Link to={"/word-pdf-converter"} class="btn btn-primary">Click Now</Link>
            </div>
          </div>
        </div>
        <div className="col-lg-3">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">PDF to Word Conversion</h5>
              <p class="card-text">
                Convert your pdf files to word
              </p>
              <Link to={"/pdf-word-converter"} class="btn btn-primary">Click Now</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
